// List of discontinued catalog definition IDs with their messages
import React from 'react';
import { AwsOracle19CCatalogDefinitionId, oracleIaaSDefinitionId } from './catalogDefinitionId';
// import { RICatalogCode003O } from '../pages/reference-implementation/utils/RICatalogCode';
// import { START_PROVISIONING_MESSAGE } from './constant';

const linkStyle = {
    color: '#4A90E2',
    textDecoration: 'underline',
};

/**
 * Configuration object for discontinued catalogs
 * Each entry contains:
 * - catalogIds: Array of catalog definition IDs
 * - recommendedAlternative: Recommended service name
 * - buttonLabel: Button label message for discontinued offering
 * - getMessage: Function that returns JSX element with the discontinued message
 */
export const discontinuedCatalogsConfig = [
    {
        catalogIds: [...oracleIaaSDefinitionId, ...AwsOracle19CCatalogDefinitionId],
        buttonLabel: 'Retired',
        getMessage: () => (
            <span>
                We recommend provisioning to <b>AWS SQL or Oracle RDS</b>, which offers a more cost-effective and reliable alternative. If access to the service
                is still required, please contact the{' '}
                <a href="mailto:dl-globalcmpoperations@pepsico.com" style={linkStyle}>
                    DevX Operations Team
                </a>{' '}
                for support. For additional information, feel free to reach out to{' '}
                <a href="mailto:DL-ITDATABASEPROVISIONINGEXCEPTION@pepsico.com" style={linkStyle}>
                    Database Team
                </a>
            </span>
        ),
    },
    // {
    //     catalogIds: [RICatalogCode003O],
    //     buttonLabel: START_PROVISIONING_MESSAGE,
    //     getMessage: () => (
    //         <span>
    //             We recommend deploying in AWS. If deployment to Azure is still required, please obtain approval from L1 leadership and contact the{' '}
    //             <a href="mailto:DL-GlobalCMPOperations@pepsico.com" style={linkStyle}>
    //                 DevX Operations
    //             </a>{' '}
    //             for support. For additional information, feel free to reach out to the{' '}
    //             <a href="mailto:DL-GlobalITCloudSolutionArchitecture@pepsico.com" style={linkStyle}>
    //                 Cloud Solutions Team
    //             </a>
    //             .
    //         </span>
    //     ),
    // },
];
/**
 * Flat array of all discontinued catalog IDs for quick lookup
 */
export const discontinuedCatalogs = discontinuedCatalogsConfig.flatMap((config) => config.catalogIds);

/**
 * Get the configuration for a specific discontinued catalog
 * @param {string} catalogCode - The catalog code to look up
 * @returns {Object|null} The configuration object or null if not found
 */
export const getDiscontinuedCatalogConfig = (catalogCode) => {
    return discontinuedCatalogsConfig.find((config) => config.catalogIds.includes(catalogCode)) || null;
};

/**
 * Get the discontinued button label for a specific catalog code
 * @param {string} catalogCode - The catalog code to look up
 * @returns {string} The button label
 */
export const getDiscontinuedButtonLabel = (catalogCode = null) => {
    const config = getDiscontinuedCatalogConfig(catalogCode);

    if (config && config.buttonLabel) {
        return config.buttonLabel;
    }

    // Default button label for other discontinued services
    return '';
};

/**
 * Get the discontinued message element for a specific catalog code
 * @param {string} catalogCode - The catalog code to look up
 * @returns {JSX.Element} The message element
 */
export const getDiscontinuedDescription = (catalogCode = null) => {
    const config = getDiscontinuedCatalogConfig(catalogCode);

    if (config && config.getMessage) {
        return config.getMessage();
    }

    // Default message for other discontinued services
    return (
        <span>
            We recommend provisioning to <b>AWS SQL or Oracle RDS</b>, which offers a more cost-effective and reliable alternative. If access to the service is
            still required, please contact the{' '}
            <a href="mailto:dl-globalcmpoperations@pepsico.com" style={linkStyle}>
                DevX Operations Team
            </a>{' '}
            for support. For additional information, feel free to reach out to{' '}
            <a href="mailto:DL-ITDATABASEPROVISIONINGEXCEPTION@pepsico.com" style={linkStyle}>
                Database Team
            </a>
        </span>
    );
};

export default discontinuedCatalogs;
